import React from 'react';
import { PropTypes } from 'prop-types';
import Yup from 'yup';
import TextInput from '../../form/controls/TextInput';
import SelectInput from '../../form/controls/SelectInput';
import StaticData from '../../../services/StaticData';
import ProjectContactService from '../../../services/ProjectContactService';

const contactFormSchema = Yup.object().shape({
  name: Yup.string().required("Contact name required"),
  email: Yup.string().required("Email required"),
  contactType: Yup.number().oneOf([0, 1, 2, 3]).required("Contact type required")
});

const fieldStyle = { width: "33%" };

class CreateContactForm extends React.Component {

  constructor(props) {
    super(props);

    this.onInputChange = this.onInputChange.bind(this);
    this.onTypeChange = this.onTypeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this._emptyContact = {
      name: "",
      email: "",
      phone: "",
      contactType: undefined
    };

    this.state = {
      error: false,
      contact: Object.assign({}, this._emptyContact)
    };
  }

  onInputChange(event) {
    this.handleValueChange(event.target.name, event.target.value);
  }

  onTypeChange(name, value) {
    this.handleValueChange(name, value.id);
  }

  handleValueChange(name, value) {
    if (name) {
      let currentState = Object.assign({}, this.state.contact);
      currentState[name] = value;
      this.setState({ contact: currentState });
    }
  }

  handleSubmit() {

    if (this.props.onCreate) {

      contactFormSchema
        .isValid(this.state.contact)
        .then(valid => {

          if (valid) {
            const newContact = Object.assign({}, this.state.contact);
            newContact.projectId = this.props.projectId;

            return ProjectContactService
              .create({ attributes: { ...newContact } })
              .then(() => this.setState({ error: null, contact: Object.assign({}, this._emptyContact) }, this.props.onCreate))
              .catch(() => this.setState({ error: { text: "Error creating contact" } }));
          }

          this.setState({ error: { text: "Invalid or missing fields" } });
        });
    }
  }

  render() {
    return (
      <div className="add-sessions" style={{ textAlign: "left" }}>
        {this.state.error && <div>{this.state.error.text}</div>}
        <label className="start" style={fieldStyle}>
          Name*
          <TextInput
            name="name"
            onChange={this.onInputChange}
            value={this.state.contact.name} />
        </label>
        <label className="start" style={fieldStyle}>
          Email*
          <TextInput
            name="email"
            type="email"
            onChange={this.onInputChange}
            value={this.state.contact.email} />
        </label>
        <label className="start" style={fieldStyle}>
          Phone
          <TextInput
            name="phone"
            onChange={this.onInputChange}
            value={this.state.contact.phone} />
        </label>
        <br />
        <label className="start" style={fieldStyle}>
          Contact type*
          <SelectInput
            name="contactType"
            options={StaticData.ContactTypes}
            onChange={this.onTypeChange}
            value={this.state.contact.contactType} />
        </label>
        <button type="button" onClick={this.handleSubmit}>Add Contact</button>
      </div>
    );
  }
}

CreateContactForm.propTypes = {
  onCreate: PropTypes.func.isRequired,
  projectId: PropTypes.number.isRequired
};

export default CreateContactForm;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectContacts/CreateContactForm.js